const style = {
  container: {
    color: "white",
    borderRadius: "4px",
    border: "1px solid #BFCFE1",
    borderBottom: "0",
  },
  tableHeadCell: {
    fontSize: "14px",
    border: "none",
    padding: "18px 8px 18px 0",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // backgroundColor: "#DDDDDD",
    whiteSpace: "nowrap",
    color: "#5E5E5E",
    fontWeight: "600",
  },
  tableBody: {
    fontSize: "14px",
    border: "none",
    color: "#000000",
  },
  emptyList: {
    display: "flex",
    justifyContent: "center",
    padding: "1rem",
    width: "100%",
    border: "1px solid #BFCFE1",
  },
};

export default style;
